import React, { ComponentPropsWithRef } from 'react';

import { omitKeys } from '@adsk/alloy-react-helpers';

import Modal from '../Modal';

type FullScreenModalProps = Omit<
  ComponentPropsWithRef<typeof Modal>,
  'size' | 'height' | 'width'
>;

/**
 * A full-screen modal component.
 */
const FullScreenModal = ({ style, ...props }: FullScreenModalProps) => (
  <Modal
    style={[
      {
        maxHeight: '100vh',
        maxWidth: '100vw',
        borderRadius: 0,
      },
      style,
    ]}
    height={'100vh'}
    width={'100vw'}
    {...props}
  />
);

FullScreenModal.SIZES = Modal.SIZES;

FullScreenModal.propTypes = {
  ...omitKeys(Modal.propTypes, ['size', 'height', 'width']),
};

export default FullScreenModal;
